import { AHIcon , AHText , Box , TouchableBox } from "arkh";



import { FormattedMessage } from "react-intl";

export function EmployeeSwitch(props: {
  currentEmployeeName: string;
  onPress: () => void;
}) {
  return (
    <TouchableBox
      style={{ flexDirection: "row", alignItems: "center", borderWidth: 1 }}
      color="surface-primary"
      borderColor="border-primary"
      cornerRadius="large"
      space="medium"
      onPress={() => {
        props.onPress();
      }}
    >
      <Box
        style={{ flexDirection: "column", justifyContent: "center", flex: 1 }}
      >
        <AHText type="detail" color="text-secondary">
          <FormattedMessage
            defaultMessage="Group Account"
            description="EmployeeSwitch: Group Account"
          />
        </AHText>
        <AHText type="title">
          <FormattedMessage
            defaultMessage="Switch Profile"
            description="EmployeeSwitch: Switch Profile"
          />
        </AHText>
      </Box>
      <AHIcon type="shuffle" size="small" color="text-secondary" />
    </TouchableBox>
  );
}
